<template>
  <div>
    <v-bottom-sheet
      v-model="showBottomSheet"
      class="color white"
      inset
    >
      <template v-slot:activator="{ on }">
        <div class="bottomSheetActivator">
          <v-btn
            v-for="list in productLists"
            :key="list.id"
            class="mb-0 mr-2"
            color="grey lighten-3"
            depressed
            large
            tile
            v-on="on"
            @click="selectProductList(list)"
          >{{ list.name }}</v-btn>
        </div>
      </template>
      <v-card>
        <v-container
          class="v-sheet"
          fluid
          grid-list-lg
        >
          <v-row
            class="justify-space-around align-center"
            wrap
          >
            <product-list-products
              v-for="list in productLists"
              v-show="selectedProductList && list.id === selectedProductList.id"
              :key="list.id"
              :list="list"
              @added-to-cart="showBottomSheet = false" />
          </v-row>
        </v-container>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import productListService from '@/services/product-lists'
import camelcaseKeys from 'camelcase-keys'
import ProductListProducts from '@/components/checkout/ProductListProducts'

export default {
  name: 'CartBottomSheet',

  components: {
    ProductListProducts
  },

  data: () => ({
    showBottomSheet: false,
    productLists: [],
    selectedProductList: null
  }),

  created () {
    // fetch productlists for store if any
    productListService.all()
      .then((data) => {
        this.productLists = camelcaseKeys(data.data.product_lists, { deep: true })
      })
  },

  methods: {
    selectProductList (list) {
      this.selectedProductList = list
    }
  }
}
</script>

<style lang="scss" scoped>
.bottomSheetActivator {
  bottom: 0;
  position: absolute;
  text-align: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/checkout/CartBottomSheet.vue